import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private activeRequests: number = 0; // Counter for active HTTP requests
  private loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  readonly isLoading$: Observable<boolean> = this.loadingSubject.asObservable();

  show(): void {
    this.activeRequests++;
    this.updateSpinnerState(); // Update spinner state based on active requests
  }

  hide(): void {
    if (this.activeRequests > 0) {
      this.activeRequests--;
    }
    this.updateSpinnerState(); // Update spinner state based on active requests
  }

  private updateSpinnerState(): void {
    // Ensure the spinner state update
    setTimeout(() => {
      this.loadingSubject.next(this.activeRequests > 0);
    });
  }
}
